import { TCRColumnLayout } from "./TCRColumnLayout";
import { ThemeContext } from "./ThemeContext";

export const TaxPreparationServicesCompany = (props) => (
	<ThemeContext.Provider
		value={{
			linkText: "View Services",
			hasTrustPilotWidget: false,
		}}
	>
		<TCRColumnLayout {...props} />
	</ThemeContext.Provider>
);
